import { useEffect, useRef } from 'react';

import { trackContentView } from '@src/services/googleAnalytics';

const useTrackContentView = ({ id, resourceType, title }) => {
    const trackedRef = useRef(null);

    useEffect(() => {
        if (!id) return;
        const trackingKey = `${resourceType || 'Content'}_${id}`;
        if (trackedRef.current === trackingKey) return;

        trackedRef.current = trackingKey;
        trackContentView({
            id,
            resourceType: resourceType || 'Content',
            title,
            page_path: typeof window !== 'undefined' ? window.location.pathname : '',
        });
    }, [id, resourceType, title]);
};

export { useTrackContentView };
